module.exports = __webpack_public_path__ + "static/media/sup_tropical_1024.b4e3b0fd.webp";